import { render, staticRenderFns } from "./ProjectReports.vue?vue&type=template&id=1c700754&scoped=true"
import script from "./ProjectReports.vue?vue&type=script&lang=js"
export * from "./ProjectReports.vue?vue&type=script&lang=js"
import style0 from "./ProjectReports.vue?vue&type=style&index=0&id=1c700754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c700754",
  null
  
)

export default component.exports